<template>
  <div class="etr">
    <b-card class="mt-3">
      <b-card-header>
        <b-row align-v="top" no-gutters>
          <b-col cols="7" class="text-left">
            <b-button
              v-print="'#paper'"
              squared
              size="sm"
              class="mr-4 inline"
              title="Print"
              :disabled="busy"
            >
              <i class="fa fa-print pr-3"></i>Print
            </b-button>
            <div class="inline-block">
              <i class="fa fa-hotel fa-2x mr-1 text-primary"></i>
              <span class="h4 ml-1 text-primary"
                >Confirmation No: {{ item.confirmationno }}</span
              >
            </div>
          </b-col>
          <b-col class="text-right">
            <b-button-group>
              <b-button
                class="mr-1"
                squared
                size="sm"
                variant="secondary"
                @click="discard"
              >
                <i class="fa fa-chevron-left pr-1"></i>Back
              </b-button>
              <b-button squared size="sm" variant="primary" @click="download()">
                <i
                  :class="
                    busy
                      ? 'fa fa-spinner fa-spin pr-3'
                      : 'fa fa-file-pdf-o pr-3'
                  "
                ></i
                >Download
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-overlay :show="busy" rounded="sm">
          <div id="paper" class="mb-3 p-4 background-white text-secondary">
            <div class="border-black p-4">
              <b-row>
                <b-col cols="2">
                  <!-- <img
                    class="logo mt-4 ml-4 h-50px"
                    src="/img/brand/ABTA.jpg"
                    alt="ABTA"
                /> -->
                </b-col>
                <b-col class="text-center"
                  ><img
                    class="logo mb-3"
                    src="/img/brand/RGB Travel Places Primary Logo.bmp"
                    alt="Travel Places"
                    height="70"
                    width="190"
                  /><br />
                  <span>
                    Travel Places, in association with American Express Global
                    Business Travel
                  </span>
                </b-col>
                <b-col cols="2">
                  <img
                    class="logo h-30px mt-4"
                    src="/img/brand/IATA.jpg"
                    alt="IATA"
                  />
                </b-col>
              </b-row>
              <b-row class="text-center strong">
                <b-col
                  >Podium House 61 Chapel Road, Worthing, West Sussex, BN11 1HR
                  T: +44 (0) 1903 832888 F: +44 (0) 1903 231179</b-col
                >
              </b-row>
            </div>
            <div class="border-black border-top-none p-4">
              <div class="text-center large strong underline">
                Hotel Voucher
              </div>

              Travel Places Agent Reference:
              <span class="strong">{{ item.agent }}</span
              ><br />
              <span v-if="agent_item.email">
                Email: <span class="strong">{{ agent_item.email }}</span>
              </span>
              <br />
            </div>
            <div class="h6 border-black border-top-none p-4">
              <span class="strong"> BOOKING DETAILS</span><br />
              <br />
              <div class="inline">
                <span class="strong text-3x">{{ item.aka }}</span>
              </div>
              <div class="inline-block">
                <b-form-rating
                  v-model="item.rating"
                  variant="primary"
                  class="mb-2"
                ></b-form-rating>
              </div>
              <br />
              <br />
              Contact Number: <span class="strong">{{ item.contactno }}</span
              ><br /><br />
              Reservation Number:
              <span class="strong">{{ item.confirmationno }} </span><br />
              <br />

              Lead Guest: <span class="strong">{{ item.leadguest }}</span
              ><br /><br />
              Room Type: <span class="strong">{{ item.equipmentname }}</span
              ><br />
              Meal Type: <span class="strong">{{ item.mealtype }}</span
              ><br />
              <span> Check In: </span>
              <span class="strong">{{ item.datecheckin }}</span>
              <span class="strong"> @ {{ item.timecheckin }}</span>
              <br />
              <span> Check Out: </span>
              <span class="strong">{{ item.datecheckout }}</span>
              <span class="strong"> @ {{ item.timecheckout }}</span>
              <br />

              People: <span class="strong">{{ item.people }}</span
              ><br />
              Rooms: <span class="strong">{{ item.qty }}</span
              ><br />
              <br />
              Date Booked:
              <span class="strong">{{ item.datebooked }} </span><br /><br />

              Details: <span class="strong">{{ item.details }}</span
              ><br /><br />
              <!-- <div v-if="item.notes">
              <br />
              <span class="strong">BOOKING NOTES </span>
              <br />
              {{ item.notes }}
            </div> -->

              <span class="strong">How to find us:</span>
              <div v-html="item.map"></div>
              <br />
            </div>
            <div class="border-black border-top-none p-4">
              <span class="strong">Company to be invoiced:</span> <br />
              Account: <span class="strong">{{ slac_item.slac }}</span> <br />
              Company: <span class="strong">{{ slac_item.name }}</span
              ><br />
              Account: <span class="strong">Paid By Travel Places</span><br />
              <!-- [ X ] Invoiced To Account [
            &nbsp;&nbsp;&nbsp; ] Direct By Client [ &nbsp;&nbsp;&nbsp; ]<br /> -->
              <!-- (paymethod: {{slac_item.paymethod}}, invoicetype: {{slac_item.invoicetype}},       accounttype: {{slac_item.accounttype}}, statementtype: {{slac_item.statementtype}}) -->
            </div>
          </div>
        </b-overlay>
      </b-card-body>

      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "HotelVoucher",
  props: ["search"],
  watch: {
    search: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.message = null;
          this.id = newVal.selected.id;
          this.load();
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      documentformat: "HTL_1",
      item: {
        items: [],
      },
      id: null,
      slac_item: {
        name: "",
        slac: "",
      },
      blac_item: {
        name: "",
        phone: "",
      },
      agent_item: {
        email: "",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    async load() {
      this.busy = true;

      let variables = {
        id: this.id,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_pg($id: String) {
              hotels_pg(id: $id) {
                id
                status
                datebooked
                agent
                eventcode
                slac
                blac
                aka
                map
                rating
                contactno
                leadguest
                people
                qty
                #roomtype
                equipmentname
                mealtype
                details
                datecheckin
                timecheckin
                datecheckout
                timecheckout
                quotedrate
                quotedtotal
                quotedterms
                confirmationno
                loyalty
                notes
                costexvat
                costvat
                costtotal
                saleexvat
                salevat
                saletotal
                vatcode
              }
            }
          `,
          variables,
        });

        this.item = response.data.hotels_pg[0];

        this.item.datebooked = this.$helpers.datefield(this.item.datebooked);
        this.item.datecheckin = this.$helpers.datefield(this.item.datecheckin);
        this.item.datecheckout = this.$helpers.datefield(
          this.item.datecheckout
        );
      } catch (error) {
        console.log(error);
      }

      this.blac_item = {
        name: "",
        phone: "",
      };
      // IF WE HAVE A BLAC
      if (this.item.blac) {
        variables = {
          blac: this.item.blac,
        };
        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query suppliers($blac: String) {
                suppliers(blac: $blac) {
                  id
                  name
                  shortname
                  blac
                  phone
                }
              }
            `,
            variables,
          });

          if (response.data.suppliers.length > 0) {
            this.blac_item = response.data.suppliers[0];
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.agent_item = {
        email: "",
      };
      // IF WE HAVE A USER
      if (this.item.agent) {
        variables = {
          initials: this.item.agent,
        };
        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query users($initials: String) {
                users(initials: $initials) {
                  id
                  name
                  email
                  initials
                }
              }
            `,
            variables,
          });

          if (response.data.users.length > 0) {
            this.agent_item = response.data.users[0];
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.slac_item = {
        name: "",
        slac: "",
      };
      // IF WE HAVE A SLAC
      if (this.item.slac) {
        variables = {
          slac: this.item.slac,
        };
        console.log("variables", variables);
        try {
          const response = await this.$apollo.query({
            query: gql`
              query clients($slac: String) {
                clients(slac: $slac) {
                  id
                  name
                  slac
                  label
                  code
                  paymethod
                  accounttype
                  invoicetype
                  statementtype
                }
              }
            `,
            variables,
          });

          if (response.data.clients.length > 0) {
            this.slac_item = response.data.clients[0];
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.busy = false;
    },
    async download() {
      this.busy = true;
      let variables = {
        id: this.search.selected.id,
        documentformat: this.documentformat,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels_pg($id: String, $documentformat: String) {
              hotels_pg(id: $id, documentformat: $documentformat) {
                id
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.hotels_old.length > 0) {
          let byteCharacters = atob(response.data.hotels_old[0].documentpdf);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, "htl_" + response.data.hotels_old[0].id + ".pdf");
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    discard() {
      this.$emit("discard");
    },
  },
};
</script>

<style>
</style>
